import { render, staticRenderFns } from "./inviteProxyList.vue?vue&type=template&id=940d032a&"
import script from "./inviteProxyList.vue?vue&type=script&lang=js&"
export * from "./inviteProxyList.vue?vue&type=script&lang=js&"
import style0 from "./inviteProxyList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports